import { headerImage as defaultheaderImage } from '../../../constant/fallback-config';
import { useConfigurationContext } from '../../../store/configurationContext';
import './CountriesAndPaymentMethodsHeader.scss';
import { useTranslation } from 'react-i18next';

const CountriesAndPaymentMethodsHeader = () => {
	const { t } = useTranslation();

	const { configurationState } = useConfigurationContext();
	const headerImage = configurationState.find((item) => item.configKey === 'header_image')?.value || '';
	return (
		<div className='head py-10' style={{ backgroundImage: `url(${headerImage})` }}>
			<h1 className='text-[32px] text-white font-bold leading-7 mb-3 text-center'>
				{t<string>('countriesPaymentMethods')}
			</h1>
			<p className='text-white text-sm text-center'>{t<string>('countriesPaymentSubtitle')}</p>
		</div>
	);
};

export default CountriesAndPaymentMethodsHeader;
